import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONES]: {
		url: '/company/:companyId/custom_geo_zones/'
	},
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONE]: {
		url: '/company/:companyId/custom_geo_zones/:customGeoZoneId/'
	},
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONE_POPUP]: {
		url: '/company/:companyId/custom_geo_zones/:customGeoZoneId/popup/'
	},
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONE_PREVIEW]: {
		url: '/company/:companyId/custom_geo_zones/:customGeoZoneId/preview/'
	},
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].CREATE_CUSTOM_GEO_ZONE]: {
		url: '/company/:companyId/custom_geo_zones/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].PUT_CUSTOM_GEO_ZONE]: {
		url: '/company/:companyId/custom_geo_zones/:customGeoZoneId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].PATCH_CUSTOM_GEO_ZONE]: {
		url: '/company/:companyId/custom_geo_zones/:customGeoZoneId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].DELETE_CUSTOM_GEO_ZONE]: {
		url: '/company/:companyId/custom_geo_zones/:customGeoZoneId/',
		requestOptions: {
			method: 'DELETE',
		},
	}
}